import {GetServerSidePropsContext, NextApiRequest, NextApiResponse, NextPageContext} from 'next';

export class ContextService {
    public static req: GetServerSidePropsContext['req'];
    public static res: GetServerSidePropsContext['res'];
    public static ctx: GetServerSidePropsContext | NextPageContext;
}

export class InitialContextService {
    public static req: NextApiRequest | NextPageContext['req'];
    public static res: NextApiResponse | NextPageContext['res'];
    public static ctx: GetServerSidePropsContext | NextPageContext;
}
